import BaseModal from '@/modal/baseModal';
import { decodeToken } from '@/utils/decodeToken';
import styles from './styles.module.scss';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import SubmitButton from '@/ui-kit/SubmitButton';

const Logout = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [timeEnded, setTimeEnded] = useState(false);

  useEffect(() => {
    const token = Cookies.get('accessToken');
    if (!token) {
      setTimeEnded(true);
      return;
    }

    const tokenExpTime = decodeToken(token).exp * 1000;
    const currentTime = new Date().getTime();
    const timeRemaining = tokenExpTime - currentTime;
    if (timeRemaining <= 0) {
      setTimeEnded(true);
      return;
    }

    const timerId = setTimeout(() => setTimeEnded(true), timeRemaining);
    return () => clearTimeout(timerId);
  }, []);

  const handleLogout = () => {
    Cookies.remove('accessToken');
    navigate('/log-in');
  };

  return (
    <>
      {timeEnded && (
        <BaseModal onClose={() => setTimeEnded(false)} width={'480px'}>
          <div className='mb-2 items-center w-full pt-6 pl-6'>
            <h6 className='mr-auto'>{t('general.logoutTitle')}</h6>
          </div>
          <p className='body2s mb-6 w-full px-6'>{t('general.logoutDescription')}</p>
          <div className={styles.modal__buttonSection}>
            <SubmitButton id='confirmLogoutButton' label={t('general.confirmLogout')} onClick={handleLogout} inputStyle='w-max' />
          </div>
        </BaseModal>
      )}
    </>
  );
};

export default Logout;
